module.exports = __webpack_public_path__ + "img/FR.ee991b86.png";